import {
	Button,
	Callout,
	Checkbox,
	Collapse,
	Intent,
	NumericInput,
	TextArea
} from "@blueprintjs/core";
import autobind from "autobind-decorator";
import { IFieldProps } from "decorator-form";
import * as React from "react";

import { EntityMultiSelect } from "common/form/fields/entitySelect/EntityMultiSelect";
import { registerField } from "common/form/register";
import { addEnum } from "typegraph";
import Logger from "../../../core/util/Logger";
import { IArticleParams } from "../entities/ArticleParams";
import Tag from "../entities/Tag";

const TagsSelect = EntityMultiSelect.ofType(
	Tag,
	{ pageSize: 1000 },
	{ getSecondaryLabel: (tag: Tag) => tag.tagSet.name }
);

// TODO make nice
class CourseParamsField extends React.PureComponent<
	IFieldProps<IArticleParams>,
	{ value: string; message: string; isOpen: boolean; intent: Intent }
> {
	constructor(props: IFieldProps<IArticleParams>) {
		super(props);
		this.state = {
			value: JSON.stringify(props.formData),
			message: null,
			isOpen: false,
			intent: Intent.NONE
		};
	}

	private handleChange = (e: any) => {
		this.setState({ value: e.target.value });
	};

	private save = () => {
		try {
			const data = JSON.parse(this.state.value);
			this.props.onChange(data);
			this.setState({
				message: "Saved",
				intent: Intent.SUCCESS,
				value: JSON.stringify(data)
			});
		} catch (e) {
			this.setState({
				message: "Invalid json. Not saved.",
				intent: Intent.DANGER
			});
		}
	};

	public render() {
		const { value, message, isOpen, intent } = this.state;

		return (
			<React.Fragment>
				<Button onClick={() => this.setState({ isOpen: !isOpen })}>
					{this.state.isOpen ? "Hide" : "Show"} editor
				</Button>
				<br />
				<Collapse isOpen={isOpen}>
					<Callout intent={Intent.NONE}>
						{message && (
							<Callout intent={intent}>{message}</Callout>
						)}
						<br />
						<TextArea
							large={true}
							intent={Intent.PRIMARY}
							onChange={this.handleChange}
							value={value}
							style={{ minHeight: "200px" }}
							fill={true}
						/>
						<br />
						<br />
						<Button onClick={this.save}>Save</Button>
					</Callout>
				</Collapse>
			</React.Fragment>
		);
	}
}

const registered = registerField(CourseParamsField, "object");
export default registered;



// WEBPACK FOOTER //
// ./src/panels/knowledgebase/config/ArticleParamsField.tsx